//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ReportRemarkImportantCheckbox',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    reportActionsAccess: {
      type: Object,
      required: true
    },
    useLabel: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      modelValueLocal: this.value,
      // available from outside
      modelValueInitial: this.value
    }
  },
  computed: {
    readonlyLocal: function () {
      return this.readonly || (this.modelValueInitial ? !this.reportActionsAccess.editImportantRemarks : !this.reportActionsAccess.setRemarkImportant && !this.reportActionsAccess.editImportantRemarks)
    }
  },
  watch: {
    modelValueLocal (val) {
      this.$emit('input', val)
    }
  }
}
